import React, { useState, useEffect } from "react";
import styleClasses from "./career.module.scss";
import { NavLink } from "react-router-dom";
import * as CONSTANT from "../../constants";
import { ChevronIcon } from "../../images/svgIcons/svg";
import { createPortal } from "react-dom";
import TeamJobs from "./teamJobs";
import { useLocation } from "react-router";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import TeamJobsMobile from "./teamJobsMobile";
import { useAuthState } from "../../context/UserAuthentication";
import { useIsDesignV2 } from "../../hooks/useIsDesignV2";
import useTrackBarVisibility from "../../hooks/useTrackBarVisibility";

export type alternateURLSeconfParams<T extends boolean> = {
  exist: boolean;
} & (T extends true ? { link: string } : { link: null });
export interface NavlinkCareer {
  text: any;
  link: string;
  alternateURL: alternateURLSeconfParams<boolean>;
}

const careerLinksArray: NavlinkCareer[] = [
  {
    text: (
      <>
        career <span className="d-none d-md-block">overview</span>
      </>
    ),
    link: CONSTANT.ROUTE_CAREERS,
    alternateURL: { exist: true, link: null },
  },
  {
    text: (
      <>
        <span className="d-none d-md-block">career</span> values
      </>
    ),
    link: CONSTANT.ROUTE_CAREERS_VALUES,
    alternateURL: { exist: false, link: null },
  },
  {
    text: (
      <>
        travel <span className="d-none d-md-block">abroad</span>
      </>
    ),
    link: CONSTANT.ROUTE_TRAVEL_ABROAD,
    alternateURL: { exist: false, link: null },
  },
];

const CareerNav = () => {
  const isItMobile = useCheckMobileScreen();
  const [isMenuShown, setIsMenuShown] = useState(false);
  const location = useLocation();
  const isDesignV2 = useIsDesignV2();

  useEffect(() => {
    setIsMenuShown(false);
  }, [location.pathname]);
  const { authInfo } = useAuthState();
  const isCheckTrackBar = useTrackBarVisibility();
  const positionLinks = [
    "/culinary-team",
    "/hospitality-team",
    "/leadership-team",
    "/catering-team",
  ];

  const handleMenu = () => {
    setIsMenuShown(true);
  };
  const handleMenuClose = () => {
    setIsMenuShown(false);
  };
  const handleMenuToggle = () => {
    setIsMenuShown(prev => !prev);
  };
  const handleMenuMouseLeave = (e) => {
    if (!e.relatedTarget || 
      (e.relatedTarget instanceof Node && !e.currentTarget.contains(e.relatedTarget))) {
      setIsMenuShown(false);
    }
  };

  return (
    <>
      <div className={`main-header-wrapper ${styleClasses.mainHeaderWrapper} ${isDesignV2 && styleClasses.mainHeaderWrapper_mobile_designv2}`}>
        <div className={`header-inner-div ${isDesignV2 && "header-inner-div_mobile_designv2"} ${styleClasses.headerInnerDiv} ${isCheckTrackBar  &&  `${styleClasses.trackBarExist}`} p-0`}>
          <ul className="d-flex align-items-center gap-3 m-0">
            {careerLinksArray.map((item, i) => {
              return (
                <NavLink
                  key={i}
                  to={item.link}
                  className={({ isActive }) =>
                    `${styleClasses.headerNavLinks} m-0 f-sm-s14 d-flex gap-1 align-items-center` +
                    (isActive && location.pathname === item.link ? ` ${styleClasses.active}` : '')
                  }
                >
                  {item.text}
                </NavLink>
              );
            })}
            <div
              className={`${styleClasses.positionWrap} position-relative`}
              onMouseOver={!isItMobile ? handleMenu : undefined}
              onMouseLeave={!isItMobile ? handleMenuMouseLeave : undefined}
              onClick={isItMobile ? handleMenuToggle : undefined}>
              <div
                className={`${
                  styleClasses.headerNavLinks
                } m-0 cursor-pointer d-flex justify-content-center align-items-center gap-2 ${
                  positionLinks.some((link) => location.pathname.includes(link))
                    ? styleClasses.active
                    : ""
                } `}>
                <span className="ps-1">positions</span>
                <span className={styleClasses.chevIconDiv}>
                  {" "}
                  <ChevronIcon />{" "}
                </span>
              </div>
              {createPortal(
                <>
                  <div
                    className={`${styleClasses.jobMega} ${
                      isMenuShown ? `isMenuShown ${isCheckTrackBar && 'trackBarExist'}` : ""
                    } jobMega ${isDesignV2 && "jobMega_mobile-designv2"}`}
                    onMouseEnter={!isItMobile ? handleMenu : undefined}
                    onMouseLeave={!isItMobile ? handleMenuMouseLeave : undefined}>
                    <div
                      className={` ${isItMobile ? "px-3" : "container"} ${
                        styleClasses.joinTeam
                      }`}>
                      {isItMobile ? <TeamJobsMobile /> : <TeamJobs />}
                    </div>
                  </div>
                  {isMenuShown && (
                    <div
                      className="menuOverlay"
                      onMouseEnter={!isItMobile ? handleMenuClose : undefined}
                      onClick={isItMobile ? handleMenuClose : undefined}></div>
                  )}
                </>,
                document.body
              )}
            </div>
          </ul>
          {/* <SmallCareerPositions /> */}
        </div>
      </div>
    </>
  );
};
export default CareerNav;
